import type { FilterState } from "../types/filterState"

interface BuildConfigParams {
  filterState: FilterState
  visibleColumns: Set<string>
  viewDescription: string
  isShared: boolean
  userEmail: string
}

export const viewConfigBuilder = {
  buildCurrentConfig: ({
    filterState,
    visibleColumns,
    viewDescription,
    isShared,
    userEmail,
  }: BuildConfigParams) => ({
    filters: {
      startDate: filterState.dateRange?.start?.toISOString(),
      endDate: filterState.dateRange?.end?.toISOString(),
      metricIds: filterState.metricIds,
      agentIds: filterState.agentIds,
      tagFilters: filterState.tagFilters,
      projectIds: filterState.projectIds,
      metadataFilters: filterState.metadataFilters,
      metricValueFilters: filterState.metricValueFilters,
    },
    display: {
      sortColumn: filterState.sortDescriptor.column?.toString(),
      sortDirection: filterState.sortDescriptor.direction,
      visibleColumns: Array.from(visibleColumns),
    },
    metadata: {
      description: viewDescription,
      isShared,
      createdBy: userEmail,
      createdAt: new Date().toISOString(),
    },
    isDefault: false,
  }),

  buildStateFromConfig: (
    filterState: FilterState,
    visibleColumns: Set<string>,
  ) => ({
    filters: {
      startDate: filterState.dateRange?.start?.toISOString(),
      endDate: filterState.dateRange?.end?.toISOString(),
      metricIds: filterState.metricIds,
      agentIds: filterState.agentIds,
      tagFilters: filterState.tagFilters,
      projectIds: filterState.projectIds,
      metadataFilters: filterState.metadataFilters,
      metricValueFilters: filterState.metricValueFilters,
    },
    display: {
      sortColumn: filterState.sortDescriptor.column?.toString(),
      sortDirection: filterState.sortDescriptor.direction,
      visibleColumns: Array.from(visibleColumns),
    },
  }),
}
